"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceCard = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _reactRedux = require("react-redux");
var _ArrowBackIosRounded = _interopRequireDefault(require("@mui/icons-material/ArrowBackIosRounded"));
var _ArrowForwardIosRounded = _interopRequireDefault(require("@mui/icons-material/ArrowForwardIosRounded"));
var _InfoRounded = _interopRequireDefault(require("@mui/icons-material/InfoRounded"));
var _material = require("@mui/material");
var _TemperatureCircleWrap = _interopRequireDefault(require("../Circles/TemperatureCircleWrap"));
var _DeviceCardModule = _interopRequireDefault(require("../../styles/components/Card/DeviceCard.module.css"));
var _OtherValuesCircleWrap = _interopRequireDefault(require("../Circles/OtherValuesCircleWrap"));
var _actions = require("../../redux/actions");
var _Title = _interopRequireDefault(require("./Title"));
var _selectors = require("../../redux/selectors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * @class DeviceCard
 *
 * @param {string} thingPDIDDevice
 * @param {string} title Custom title
 * @param {boolean} inSwiper Is the card on the swiper
 * @param {string} className
 * @return {JSX.Element}
 * @constructor
 *
 * @public
 */
const DeviceCard = _ref => {
  let {
    thingPDIDDevice,
    className = '',
    title = '',
    inSwiper = false
  } = _ref;
  const dispatch = (0, _reactRedux.useDispatch)();
  const [hover, setHover] = (0, _react.useState)(false);
  const {
    thingProductDisplayClassification,
    displayNameId = []
  } = (0, _reactRedux.useSelector)((0, _selectors.selectDeviceByPdid)(thingPDIDDevice)) || {};
  const handleMouseLeave = (0, _react.useCallback)(() => {
    setHover(false);
  }, []);
  const handleMouseEnter = (0, _react.useCallback)(() => {
    setHover(true);
  }, []);
  const handleInfo = (0, _react.useCallback)(() => {
    dispatch((0, _actions.setInfoModal)({
      open: true
    }));
  }, [dispatch]);
  const sensorType = (0, _react.useMemo)(() => _paulCorePackage.functions.getDisplayClassification(thingProductDisplayClassification), [thingProductDisplayClassification]);
  const temperatureDisplayNameIdList = displayNameId.filter(id => _paulCorePackage.constants.regularsByDisplayNameId.temperatureRegex.test(id));
  const isLargeCard = sensorType === _paulCorePackage.constants.sensorTypes.energyValve || temperatureDisplayNameIdList.length > 1;
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, thingPDIDDevice ? /*#__PURE__*/_react.default.createElement(_paulCorePackage.Card, {
    className: "".concat(_DeviceCardModule.default.container, " sensor-card ").concat(className),
    sx: {
      minWidth: isLargeCard ? 420 : 233,
      width: isLargeCard ? 420 : 233,
      height: 366
    },
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    theme: {
      text_align: 'center',
      padding: '29px 12px 26px'
    },
    withHeader: false,
    classNameCustomIcon: _DeviceCardModule.default.customIconWrap,
    customIcon: sensorType === _paulCorePackage.constants.sensorTypes.energyValve && /*#__PURE__*/_react.default.createElement(_material.IconButton, {
      className: _DeviceCardModule.default.infoBtn,
      onClick: handleInfo
    }, /*#__PURE__*/_react.default.createElement(_InfoRounded.default, null))
  }, /*#__PURE__*/_react.default.createElement(_Title.default, {
    title: title,
    thingPDIDDevice: thingPDIDDevice
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "h-100 flex-column justify-content-end"
  }, sensorType === _paulCorePackage.constants.sensorTypes.energyValve ? /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      minHeight: 257
    },
    className: "w-100"
  }, /*#__PURE__*/_react.default.createElement(_paulCorePackage.Slider, {
    settings: inSwiper ? {
      noSwiping: 'true',
      noSwipingClass: 'swiper-slide'
    } : {},
    keys: [1, 2],
    buttons: {
      left: /*#__PURE__*/_react.default.createElement(_ArrowBackIosRounded.default, {
        sx: {
          color: '#00205B'
        }
      }),
      right: /*#__PURE__*/_react.default.createElement(_ArrowForwardIosRounded.default, {
        sx: {
          color: '#00205B'
        }
      })
    },
    buttonStyle: {
      left: {
        transform: 'translateY(-39px)'
      },
      right: {
        transform: 'translateY(-39px)'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_TemperatureCircleWrap.default, {
    thingPDIDDevice: thingPDIDDevice,
    hover: hover
  }), /*#__PURE__*/_react.default.createElement(_OtherValuesCircleWrap.default, {
    thingPDIDDevice: thingPDIDDevice,
    hover: hover
  }))) : /*#__PURE__*/_react.default.createElement(_TemperatureCircleWrap.default, {
    thingPDIDDevice: thingPDIDDevice,
    hover: hover
  }))) : null), [thingPDIDDevice, title, className, sensorType, inSwiper, hover, isLargeCard]);
};
exports.DeviceCard = DeviceCard;